module.exports = __webpack_public_path__ + "assets/4ac08828761b8ef7dedf7da5eb89fd9b.png";